import React from "react";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";
import Cube from "examples/Icons/Cube";
import Business from "./layouts/business";
import Customer from "./layouts/customer";
import ProductCategory from "./layouts/productCategory";
import Country from "./layouts/country";
import DiscountCard from "./layouts/discountCard";
import DiscountCardIssue from "./layouts/discountCardIssue";
import Map from "./layouts/map";
import Journey from "./layouts/journey";
import Qrcode from "./layouts/qrcode";
import Penalty from "./layouts/penalty";
import Banner from "./layouts/banner";
import RatingFactor from "./layouts/ratingFactor";
import ProductTag from "./layouts/productTag";
import Feature from "./layouts/feature";
import Person from "./layouts/person";
import Mug from "./layouts/mug";
import BusinessSuggestion from "./layouts/businessSuggestion";
import NearbyVisitStats from "layouts/nearbyVisitStats";
import TicketManagement from "./layouts/ticket";


const routes = [
    {
        type: "collapse",
        name: "کسب و کار",
        key: "business-group",
        icon: <Office size="12px" />,
        children: [
            {
                name: "کسب و کار",
                key: "business",
                route: "/business",
                component: <Business />,
            },
            {
                name: "پیشنهادات کسب و کار",
                key: "businessSuggestion",
                route: "/businessSuggestion",
                component: <BusinessSuggestion />,
            },
            {
                name: "بازدید های نزدیک",
                key: "nearby-visit-stats",
                route: "/nearby-visit-stats",
                component: <NearbyVisitStats />,
            },
        ],
    },
    {
        type: "collapse",
        name: "محصولات",
        key: "products-group",
        icon: <Document size="12px" />,
        children: [
            {
                name: "دسته بندی محصولات",
                key: "product-category",
                route: "/product-category",
                component: <ProductCategory />,
            },
            {
                name: "تگ محصولات",
                key: "productTag",
                route: "/productTag",
                component: <ProductTag />,
            },
            {
                name: "ویژگی",
                key: "feature",
                route: "/feature",
                component: <Feature />,
            },
        ],
    },
    {
        type: "collapse",
        name: "تخفیف",
        key: "discount-group",
        icon: <CreditCard size="12px" />,
        children: [
            {
                name: "کارت تخفیف",
                key: "discountCard",
                route: "/discountCard",
                component: <DiscountCard />,
            },
            {
                name: "کارت تخفیف کسب و کار",
                key: "discountCardIssue",
                route: "/discountCardIssue",
                component: <DiscountCardIssue />,
            },
        ],
    },
    {
        type: "collapse",
        name: "محتوا",
        key: "content-group",
        icon: <SpaceShip size="12px" />,
        children: [
            {
                name: "بنر",
                key: "banner",
                route: "/banner",
                component: <Banner />,
            },
            {
                name: "چالش",
                key: "journey",
                route: "/journey",
                component: <Journey />,
            },
            {
                name: "QR",
                key: "qrcode",
                route: "/qrcode",
                component: <Qrcode />,
            },
        ],
    },
    {
        type: "collapse",
        name: "پشتیبانی",
        key: "support-group",
        icon: <CustomerSupport size="12px" />,
        children: [
            {
                name: "مدیریت تیکت‌ها",
                key: "ticket-management",
                route: "/tickets",
                component: <TicketManagement />,
            },
        ],
    },
    {
        type: "collapse",
        name: "سایر",
        key: "other-group",
        icon: <Cube size="12px" />,
        children: [
            {
                name: "مشتری",
                key: "customer",
                route: "/customer",
                component: <Customer />,
            },
            {
                name: "کشور",
                key: "country",
                route: "/country",
                component: <Country />,
            },
            {
                name: "نقشه",
                key: "map",
                route: "/map",
                component: <Map />,
            },
            {
                name: "جریمه",
                key: "penalty",
                route: "/penalty",
                component: <Penalty />,
            },
            {
                name: "رای گیری",
                key: "ratingFactor",
                route: "/ratingFactor",
                component: <RatingFactor />,
            },
            {
                name: "اشخاص",
                key: "person",
                route: "/person",
                component: <Person />,
            },
            {
                name: "ماگ",
                key: "mug",
                route: "/mug",
                component: <Mug />,
            },
        ],
    },
];

export default routes;
